import React from 'react';

import FaqsApi, { ChangeOrderDirection } from '../../../Api/CRM/Modules/FaqsApi';
import Faq from '../../../Api/Models/Faq';
import TrueFalseIcon from '../../../components/common/TrueFalseIcon';
import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import TableHead from '../../elements/common/TableHead';
import TableLoader, { markModelListRow } from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function FaqList({ agents = false }: { agents?: boolean }) {
    const { languageNames } = useGlobalState();
    const { items, isLoading, updateItems, auto } = useAutoPaginator<Faq>((page, params) =>
        FaqsApi.getAll(page, agents, { params })
    );
    async function handleClick(event: React.MouseEvent, faq: Faq, direction: ChangeOrderDirection) {
        event.preventDefault();
        markModelListRow(faq.id);
        const changedFaq = await FaqsApi.changeOrder(faq.id, direction);

        if (changedFaq.order !== faq.order) {
            await updateItems();
            markModelListRow(changedFaq.id);
        }
    }

    return (
        <Card title={agents ? 'All Agents Faq' : 'All Faq'}>
            <ActionButton url="/faq/create" title="Create new faq" permissions={[PERMISSION.CREATE_FAQ]} />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Order</th>
                        <th>Action</th>
                        <th>Question</th>
                        <th>Language</th>
                        <th>Translation of</th>
                        <th>Is mobile</th>
                    </TableHead>
                    <tbody>
                        {items.map((faq) => (
                            <tr key={`${faq.id}-${faq.order}`} id={`model-list-row-${faq.id}`}>
                                <td>
                                    <span className="mr-2">{faq.order}</span>
                                    <a href="#" onClick={(e) => handleClick(e, faq, 'up')}>
                                        <i className="far fa-arrow-alt-circle-up mr-1 fa-2x align-middle" />
                                    </a>
                                    {faq.order !== 1 && (
                                        <a href="#" onClick={(e) => handleClick(e, faq, 'down')}>
                                            <i className="far fa-arrow-alt-circle-down fa-2x align-middle" />
                                        </a>
                                    )}
                                </td>
                                <td>
                                    <ViewButton url={`/faq/${faq.id}`} permissions={[PERMISSION.VIEW_FAQ]} />
                                    <EditButton url={`/faq/${faq.id}/edit`} permissions={[PERMISSION.UPDATE_FAQ]} />
                                    <DeleteButton
                                        url={`/crea/api/faq/${faq.id}`}
                                        action={updateItems}
                                        permissions={[PERMISSION.DELETE_FAQ]}
                                    />
                                </td>
                                <td>{faq.question}</td>
                                <td>{languageNames[faq.language_id]}</td>
                                <td>{faq.translation_id}</td>
                                <td>
                                    <TrueFalseIcon status={faq.is_mobile} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

export default FaqList;
